import { FC, HTMLAttributes } from 'react';

type AndroidProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const Android: FC<AndroidProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C3.5815 0 0 3.5815 0 8C0 12.418 3.5815 16 8 16C12.4185 16 16 12.418 16 8C16 3.5815 12.4185 0 8 0Z"
        fill="black"
      />
      <path
        d="M4.58975 5.82605C4.24725 5.82605 3.96875 6.10405 3.96875 6.44705V8.93055C3.96875 9.27305 4.24675 9.55155 4.58975 9.55155C4.93275 9.55155 5.21075 9.27355 5.21075 8.93055V6.44705C5.21075 6.10405 4.93225 5.82605 4.58975 5.82605Z"
        fill="white"
      />
      <path
        d="M11.4179 5.82605C11.0754 5.82605 10.7969 6.10405 10.7969 6.44705V8.93055C10.7969 9.27305 11.0749 9.55155 11.4179 9.55155C11.7609 9.55155 12.0389 9.27355 12.0389 8.93055V6.44705C12.0389 6.10405 11.7609 5.82605 11.4179 5.82605Z"
        fill="white"
      />
      <path
        d="M5.52344 10.7936H6.14444V12.3461C6.14444 12.6886 6.42244 12.9671 6.76544 12.9671C7.10844 12.9671 7.38644 12.6891 7.38644 12.3461V10.7936H8.62844V12.3461C8.62844 12.6886 8.90644 12.9671 9.24944 12.9671C9.59244 12.9671 9.87044 12.6891 9.87044 12.3461V10.7936H10.4914V6.1366H5.52394V10.7936H5.52344Z"
        fill="white"
      />
      <path
        d="M9.47394 3.82459L9.79294 3.27209C9.83594 3.19759 9.81044 3.10309 9.73594 3.05959C9.66194 3.01659 9.56694 3.04209 9.52394 3.11659L9.21244 3.65509C8.85544 3.45659 8.44494 3.34259 8.00744 3.34259C7.56994 3.34259 7.15944 3.45659 6.80244 3.65559L6.49144 3.11659C6.44844 3.04259 6.35394 3.01709 6.27894 3.05959C6.20494 3.10259 6.17944 3.19709 6.22194 3.27159L6.54094 3.82409C5.92544 4.27609 5.52344 5.00309 5.52344 5.82609H10.4909C10.4909 5.00359 10.0894 4.27659 9.47394 3.82459ZM7.07594 4.89459C6.90444 4.89459 6.76544 4.75559 6.76544 4.58409C6.76544 4.41259 6.90444 4.27359 7.07594 4.27359C7.24744 4.27359 7.38644 4.41259 7.38644 4.58409C7.38644 4.75609 7.24794 4.89459 7.07594 4.89459ZM8.93894 4.89459C8.76744 4.89459 8.62844 4.75559 8.62844 4.58409C8.62844 4.41259 8.76744 4.27359 8.93894 4.27359C9.11044 4.27359 9.24944 4.41259 9.24944 4.58409C9.24944 4.75609 9.11044 4.89459 8.93894 4.89459Z"
        fill="white"
      />
    </svg>
  );
};

export default Android;
